import React from 'react';
import WorkspaceHome from '../../components/workspace/WorkspaceHome';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { WORKSPACE_LABEL } from '../../config/branding';

const WorkspacePage = () => {
  useDocumentTitle(WORKSPACE_LABEL);
  return <WorkspaceHome />;
};

export default WorkspacePage;
